import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const RouteLoadingSpinner: React.FC = () => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(2px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9998,
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          padding: '24px 32px',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(0, 0, 0, 0.06)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minWidth: '200px',
        }}
      >
        <div style={{ marginBottom: '12px' }}>
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 24,
                  color: '#1890ff',
                }}
                spin
              />
            }
          />
        </div>
        <p
          style={{
            margin: 0,
            fontSize: 14,
            color: '#666',
            textAlign: 'center',
            fontWeight: 500,
          }}
        >
          Loading page...
        </p>
      </div>
    </div>
  );
};

export default RouteLoadingSpinner;
